<h2 mat-dialog-title>{{ isNew ? "New Group" : "Edit Group" }}</h2>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-5"><mat-form-field class="full-width"><mat-label>Name</mat-label><input matInput [(ngModel)]="result.name" name="gn" /></mat-form-field></div>
    <div class="col-md-3"><mat-form-field class="full-width"><mat-label>Sort order</mat-label><input matInput type="number" [(ngModel)]="result.sortOrder" name="gso" /></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Idle days before purge (blank = default)</mat-label><input matInput type="number" [(ngModel)]="result.idleDays" name="gid" /></mat-form-field></div>
  </div>
  <mat-form-field class="full-width"><mat-label>Description</mat-label><input matInput [(ngModel)]="result.description" name="gd" /></mat-form-field>
  <mat-form-field class="full-width"><mat-label>Tables in this Group</mat-label>
    <mat-select [value]="result.tableIds" (selectionChange)="onTablesSelected($event.value)" multiple>
      <mat-option *ngFor="let t of data.tables" [value]="t.admTableId">{{ t.tableName }}</mat-option>
    </mat-select></mat-form-field>
  <p class="text-muted" *ngIf="result.tableIds.length > 1" style="margin: 4px 0">
    Drag <span class="fas fa-grip-vertical"></span> to set the order subscribers see these tables in.
  </p>
  <div cdkDropList (cdkDropListDropped)="dropTable($event)">
    <div *ngFor="let id of result.tableIds" cdkDrag style="display: flex; align-items: center; height: 30px; border-bottom: 1px solid #f0f0f0">
      <span class="fas fa-grip-vertical" cdkDragHandle style="cursor: move; margin-right: 8px" title="Drag to reorder"></span>
      {{ data.tableName(id) }}
    </div>
  </div>
  <mat-form-field class="full-width"><mat-label>Restrict to these columns (optional - leave empty to offer every selectable column of each table)</mat-label>
    <mat-select [(value)]="result.allowedColumnIds" multiple>
      <mat-option *ngFor="let c of allowlistCandidates" [value]="c.admTableColumnId">{{ columnLabel(c) }}</mat-option>
    </mat-select></mat-form-field>
  <p class="text-muted">
    If you list any column of a table here, only the columns you list are offered through this Group for that table.
    Flattened columns belong to their parent table and are restricted the same way.
  </p>
  <mat-checkbox [(ngModel)]="result.active" name="ga">Active</mat-checkbox>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()">Save Group</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
